export enum TruckStatus {
  Unknown = 0,
  Processing = 1,
  Active = 2,
  Repairing = 3,
  Returning = 4,
  Returned = 5,
  Dispute = 6,
  OutOfSystem = 7
}

export const TruckStatusMapping: Record<TruckStatus, string> = {
  [TruckStatus.Unknown]: 'Unknown',
  [TruckStatus.Processing]: 'Processing',
  [TruckStatus.Active]: 'Active',
  [TruckStatus.Repairing]: 'Repairing',
  [TruckStatus.Returning]: 'Processing Out',
  [TruckStatus.Returned]: 'Returned / Gone',
  [TruckStatus.Dispute]: 'In Dispute',
  [TruckStatus.OutOfSystem]: 'Out of FedEx'
};
